var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.container},_vm._l((_vm.items),function(item,index){
var _obj;
return _c('li',{key:index,class:[[_vm.$style.item], ( _obj = {}, _obj[_vm.$style.isSelected] = _vm.isSelected(index), _obj )],on:{"click":function($event){return _vm.onSelect(index)}}},[_vm._v("\n    "+_vm._s(item.option_menu)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }